/**
 * Right-to-left admin locales: the widget's `RTL_LOCALES` (plan §6.4). The
 * admin chrome stays left-to-right; only the assistant's own content (the
 * widget, the panel state header, the coachmark text) mirrors for them.
 */
export const ASSISTANT_RTL_LOCALES: readonly string[] = ['ar', 'ur'];

/** Whether the assistant content reads right-to-left in `locale` (a code or BCP 47 tag). */
export function isAssistantRtl(locale: string | null | undefined): boolean {
  if (!locale) return false;
  const primary = locale.split('-')[0].toLowerCase();
  return ASSISTANT_RTL_LOCALES.includes(primary);
}
